import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from '@ngx-gallery/core';

@Component({
  selector: 'takeoff-group-gallery-view',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class GalleryComponent implements OnInit {

  @Input() imageData = [];

  items: GalleryItem[];

  constructor(public gallery: Gallery) {
  }

  ngOnInit() {
    this.items = this.imageData.map(item =>
      new ImageItem({ src: item, thumb: item })
    );
    this.basicLightboxExample();
    this.withCustomGalleryConfig();
  }

  basicLightboxExample() {
    this.gallery.ref().load(this.items);
  }

  withCustomGalleryConfig() {
    const lightboxGalleryRef = this.gallery.ref('anotherLightbox');
    lightboxGalleryRef.setConfig({
      imageSize: ImageSize.Cover,
      thumbPosition: ThumbnailsPosition.Top
    });
    lightboxGalleryRef.load(this.items);
  }
}
